module.exports = __webpack_public_path__ + "img/cloth_g1_sleeve_15.996c86da.svg";